(function () {
  const VISIBLE_CLASS = 'is-visible';
  const ROOT_CLASS = 'qeviq-sticky-atc-active';

  function getProductInfo() {
    return document.querySelector('product-info.product-info--qeviq');
  }

  function hasRoutinePlans() {
    return Boolean(getProductInfo()?.querySelector('[data-qbs-plans]'));
  }

  function QeviqStickyAtc(bar) {
    this.bar = bar;
    this.productInfo = getProductInfo();
    this.anchor = document.getElementById('qeviq-buy-cta');
    this.footer = document.querySelector('.qeviq-footer, footer, [id^="QeviqFooter-"]');
    this.variantEl = bar.querySelector('[data-qeviq-sticky-variant]');
    this.priceEl = bar.querySelector('[data-qeviq-sticky-price]');
    this.submitBtn = bar.querySelector('[data-qeviq-sticky-submit]');
    this.imageEl = bar.querySelector('.qeviq-pdp-sticky-atc__image');
    this.sectionId = bar.dataset.sectionId;
    this.routineMode = hasRoutinePlans();
    this.visible = false;
    this.onScroll = this.onScroll.bind(this);
    this.onResize = this.onResize.bind(this);
    this.syncContent = this.syncContent.bind(this);
    this.syncVisibility = this.syncVisibility.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onRoutineChange = this.onRoutineChange.bind(this);
  }

  QeviqStickyAtc.prototype.init = function () {
    if (!this.anchor || !this.productInfo) return;

    this.syncContent();
    this.bindSyncEvents();

    if (this.routineMode && this.submitBtn) {
      this.submitBtn.removeAttribute('data-qeviq-scroll-to-purchase');
      this.submitBtn.addEventListener('click', this.onSubmit);
      if (window.QeviqSharedAddToCart?.registerButton) {
        window.QeviqSharedAddToCart.registerButton(this.submitBtn, 'bundle');
      }
    }

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize, { passive: true });

    this.onScroll();
  };

  QeviqStickyAtc.prototype.bindSyncEvents = function () {
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, () => {
        window.requestAnimationFrame(this.syncContent);
      });
    }

    document.addEventListener('product-info:loaded', this.syncContent);
    document.addEventListener('qeviq:routine-plan-change', this.onRoutineChange);
  };

  QeviqStickyAtc.prototype.getSelectedPlanCard = function () {
    const checked = this.productInfo?.querySelector('[data-qbs-plan-radio]:checked');
    return checked?.closest('[data-qbs-plan-card]') || null;
  };

  QeviqStickyAtc.prototype.getSelectedVariantLabel = function () {
    if (this.routineMode) {
      const planCard = this.getSelectedPlanCard();
      const planTitle = planCard?.querySelector('.qbs-plan__title')?.textContent?.trim();
      if (planTitle) return planTitle;

      const valueEl = this.productInfo.querySelector('[data-selected-value]');
      if (valueEl?.textContent?.trim()) return valueEl.textContent.trim();
    }

    const valueEl = this.productInfo.querySelector('[data-selected-value]');
    if (valueEl?.textContent?.trim()) return valueEl.textContent.trim();

    const checked = this.productInfo.querySelector('variant-selects input:checked, .variant-input input:checked');
    const label = checked?.closest('label')?.textContent?.trim();
    if (label) return label.replace(/\s*Variant uitverkocht.*/i, '').trim();

    return '';
  };

  QeviqStickyAtc.prototype.onRoutineChange = function () {
    window.requestAnimationFrame(this.syncContent);
  };

  QeviqStickyAtc.prototype.syncSubmitState = function () {
    if (!this.routineMode || !this.submitBtn) return;

    const planCard = this.getSelectedPlanCard();
    const flow = planCard?.dataset.flow || 'bundle';
    const bundleAvailable = planCard?.dataset.bundleAvailable !== 'false';
    const shouldDisable = flow === 'bundle' && !bundleAvailable;

    this.submitBtn.toggleAttribute('disabled', shouldDisable);
    this.submitBtn.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');

    if (window.QeviqSharedAddToCart?.registerButton) {
      window.QeviqSharedAddToCart.registerButton(
        this.submitBtn,
        flow === 'standalone' ? 'standalone' : 'bundle'
      );
    }

    const labelSpan = this.submitBtn.querySelector('span');
    if (labelSpan) {
      labelSpan.textContent = flow === 'standalone' ? 'ADD TO CART' : 'ADD TO CART';
    }
  };

  QeviqStickyAtc.prototype.syncContent = function () {
    if (!this.productInfo) return;

    const variantLabel = this.getSelectedVariantLabel();
    if (this.variantEl) {
      if (variantLabel) {
        this.variantEl.textContent = variantLabel;
        this.variantEl.hidden = false;
      } else {
        this.variantEl.textContent = '';
        this.variantEl.hidden = true;
      }
    }

    const livePrice = this.sectionId
      ? document.getElementById(`price-${this.sectionId}`)
      : this.productInfo.querySelector('[id^="price-"]');
    if (this.priceEl && livePrice) {
      this.priceEl.innerHTML = livePrice.innerHTML;
    }

    const liveMedia = this.productInfo.querySelector('.product__media-item.is-active img, .product-media-container img');
    if (this.imageEl && liveMedia?.currentSrc) {
      this.imageEl.src = liveMedia.currentSrc;
      if (liveMedia.alt) this.imageEl.alt = liveMedia.alt;
    }

    this.syncSubmitState();
  };

  QeviqStickyAtc.prototype.onSubmit = function (event) {
    if (!this.routineMode || !window.QeviqSharedAddToCart) return;

    event.preventDefault();
    event.stopPropagation();

    const planCard = this.getSelectedPlanCard();
    const flow = planCard?.dataset.flow || 'bundle';

    if (flow === 'standalone') {
      window.QeviqSharedAddToCart.handleStandaloneClick(this.submitBtn, event);
      return;
    }

    window.QeviqSharedAddToCart.handleBundleSubmit(this.submitBtn, event);
  };

  QeviqStickyAtc.prototype.measureVisibility = function () {
    if (!this.anchor) {
      return { shouldShow: false };
    }

    const viewportHeight = window.innerHeight;
    const anchorRect = this.anchor.getBoundingClientRect();
    const anchorVisible = anchorRect.bottom > 0 && anchorRect.top < viewportHeight;
    const notYetReached = anchorRect.top >= viewportHeight;
    const scrolledPastAnchor = anchorRect.bottom <= -8;

    let footerReached = false;
    if (this.footer) {
      const footerRect = this.footer.getBoundingClientRect();
      footerReached = footerRect.top < viewportHeight && footerRect.bottom > 0;
    }

    let shouldShow;
    if (this.visible) {
      shouldShow = !anchorVisible && !notYetReached && !footerReached;
    } else {
      shouldShow = scrolledPastAnchor && !notYetReached && !footerReached;
    }

    return { shouldShow };
  };

  QeviqStickyAtc.prototype.syncVisibility = function () {
    const { shouldShow } = this.measureVisibility();

    if (shouldShow === this.visible) return;

    this.visible = shouldShow;
    this.bar.classList.toggle(VISIBLE_CLASS, shouldShow);
    this.bar.toggleAttribute('hidden', !shouldShow);
    this.bar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    document.documentElement.classList.toggle(ROOT_CLASS, shouldShow);
  };

  QeviqStickyAtc.prototype.onScroll = function () {
    window.cancelAnimationFrame(this.raf);
    this.raf = window.requestAnimationFrame(this.syncVisibility);
  };

  QeviqStickyAtc.prototype.onResize = function () {
    this.onScroll();
    this.syncContent();
  };

  function initAll() {
    document.querySelectorAll('[data-qeviq-sticky-atc]').forEach((bar) => {
      if (bar.dataset.qeviqStickyInit === 'true') return;
      bar.dataset.qeviqStickyInit = 'true';
      const instance = new QeviqStickyAtc(bar);
      instance.init();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('product-info:loaded', initAll);
})();
